export const VIEWPORTS = {
  large: [1024],
  medium: [640, 1025],
  mediumLarge: [640],
  small: [0, 641],
  smallMedium: [0, 1025]
}

export const SMALL_SCREEN_SIZE = {
  large: false,
  medium: false,
  mediumLarge: false,
  small: true,
  smallMedium: true
}

export const LARGE_SCREEN_SIZE = {
  large: true,
  medium: false,
  mediumLarge: true,
  small: false,
  smallMedium: false
}

export default LARGE_SCREEN_SIZE

export const MAXIMUM_WRAPPER_WIDTH = 1220
